import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ProductsState,
  CreateProductProps,
  UpdateProductProps,
  // ProductDetailState,
  // ProductAdditionalState,
  // ProductTypeState,
  // ProductDashboardState,
  ProductsProps,
  ShowProductProps,
  DeleteProductProps,
} from "./types";
// import { PaginationProps } from "src/redux/types";
import ApiService from "services/ApiService";

export const getProductList = createAsyncThunk(
  "products/get",
  async ({
    search,
    page_no,
    page_size,
    sort_by,
    sort_direction,
    token,
    is_service,
    merchant_id,
    category_id,
    is_gift
  }: ProductsProps) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/api/v1/products?page_no=${page_no ? page_no : 10
        }&page_size=${page_size ? page_size : 1}&sort_by=${sort_by ? sort_by : "profile_name"
        }&sort_direction=${sort_direction ? sort_direction : "asc"}${search ? `&search=${search}` : ""
        }${is_service !== undefined ? `&is_service=${is_service}` : ""}&merchant_id=${merchant_id}${category_id ? `&category_id=${category_id}` : ""}${is_gift !== undefined ? `&is_gift=${is_gift}` : ''}`,
        config
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as ProductsState;
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        } as unknown as ProductsState;
      }
    } catch (err) {
      if (err)
        return {
          data: "Something went wrong!",
          status: "error",
          error: err,
        } as unknown as ProductsState;
    }
  }
);

export const showProduct = createAsyncThunk(
  "products/show",
  async ({ product_id, token }: ShowProductProps) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/api/v1/products/${product_id}`,
        config
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as ProductsState;
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        } as unknown as ProductsState;
      }
    } catch (err) {
      if (err)
        return {
          data: "Something went wrong!",
          status: "error",
          error: err,
        } as unknown as ProductsState;
    }
  }
);

export const createNewProducts = createAsyncThunk(
  "products/post",
  async (data: CreateProductProps) => {
    const payload = { 
      ...data.dataAdd, 
      isService: data.isService, 
      merchantId: data.merchantId,
      userId: data.userId,
    };
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      };
      const response = await ApiService.post(
        `${process.env.REACT_APP_API_URL}/api/v1/products`,
        payload,
        config
      );
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as ProductsState;
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        } as unknown as ProductsState;
      }
    } catch (err) {
      if (err)
        return {
          data: "Something went wrong!",
          status: "error",
          error: err,
        } as unknown as ProductsState;
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "products/delete",
  async ({ product_id, token }: DeleteProductProps) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.delete(
        `${process.env.REACT_APP_API_URL}/api/v1/products/${product_id}`,
        config
      );

      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as ProductsState;
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        } as unknown as ProductsState;
      }
    } catch (err) {
      if (err)
        return {
          data: "Something went wrong!",
          status: "error",
          error: err,
        } as unknown as ProductsState;
    }
  }
);

export const updateProduct = createAsyncThunk(
  "products/put",
  async (data: UpdateProductProps) => {
    try {
      const payload = { 
        ...data.dataAdd, 
        isService: data.isService, 
        merchantId: data.merchantId, 
        userId: data.userId,
      }
      const config = {
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      };
      const response = await ApiService.put(
        `${process.env.REACT_APP_API_URL}/api/v1/products/${data.dataAdd.id}`,
        payload,
        config
      );
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        } as unknown as ProductsState;
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        } as unknown as ProductsState;
      }
    } catch (err) {
      if (err)
        return {
          data: "Something went wrong!",
          status: "error",
          error: err,
        } as unknown as ProductsState;
    }
  }
);

export const getProductUnits = createAsyncThunk(
  "product/units",
  async ({ token }: { token: string }) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/api/v1/units`,
        config
      );
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        }
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        }
      }
    } catch (error) {
      if (error) {
        return {
          data: "Something went wrong!",
          status: "error",
          error
        }
      }
    }
  }
)

export const getProductStockHistory = createAsyncThunk(
  "product-stock-history",
  async (data: any) => {
    try {
       const config = {
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      };

      const response = await ApiService.get(
        `${process.env.REACT_APP_API_URL}/api/v1/stock-history/${data.productId}?page_no=${data.page_no ?? 0
        }&page_size=${data.page_size ?? 10}&sort_by=${data.sort_by ?? "createdAt"
        }&sort_direction=${data.sort_direction ?? "desc"}${data.search ? `&search=${data.search}`:""}`,
        config
      );
      if (response && response.data) {
        return {
          data: response.data,
          status: "success",
          error: null,
        }
      } else {
        return {
          data: response.data?.message,
          status: "empty",
          error: null,
        }
      }
    } catch (error) {
      if (error) {
        return {
          data: "Something went wrong!",
          status: "error",
          error
        }
      }
    }
  }
)